function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import map from 'lodash/map';
import messages from '../../../messages';
import Marker from '../Marker';
import styles from './Header.pcss';
const LegendItems = [
    {
        title: messages.legends.approximateTime,
        Example: ()=>/*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text--bold text--uppercase",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.key))
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "d-flex align-items-center",
                        children: "~"
                    })
                ]
            })
    },
    {
        title: messages.legends.injection,
        Example: ()=>/*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Marker, {
                    type: "overlapingInjections",
                    values: [
                        '#',
                        '##'
                    ]
                })
            })
    },
    {
        title: messages.legends.manualReading,
        Example: ()=>/*#__PURE__*/ _jsx("div", {
                className: styles.readingMock,
                children: ' '
            })
    },
    {
        title: messages.legends.twoHoursApartReadings,
        Example: ()=>/*#__PURE__*/ _jsxs("div", {
                className: styles.overlappingReadingMock,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.readingMock,
                        children: "#"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.readingMock,
                        children: "#"
                    })
                ]
            })
    }
];
const Legend = ()=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.dailyLogReport__legend,
        children: /*#__PURE__*/ _jsx("div", {
            children: map(LegendItems, ({ title, Example }, idx)=>/*#__PURE__*/ _jsxs("div", {
                    className: styles.dailyLogReport__legendRow,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mr-3",
                            children: /*#__PURE__*/ _jsx(Example, {})
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, title))
                        })
                    ]
                }, idx))
        })
    });
};
export default Legend;
